import { render, staticRenderFns } from "./QCreateSupportTicket.vue?vue&type=template&id=7a9c1829&scoped=true&"
import script from "./QCreateSupportTicket.vue?vue&type=script&lang=js&"
export * from "./QCreateSupportTicket.vue?vue&type=script&lang=js&"
import style0 from "./QCreateSupportTicket.vue?vue&type=style&index=0&id=7a9c1829&prod&scoped=true&lang=css&"
import style1 from "./QCreateSupportTicket.vue?vue&type=style&index=1&id=7a9c1829&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9c1829",
  null
  
)

export default component.exports